import {
  GET_NOTIFICATIONS,
  GET_UNREAD_COUNT,
  MARK_NOTIFICATIONS_READ,
  DELETE_NOTIFICATIONS,
  NOTIFICATION_ERROR,
  CLEAR_NOTIFICATIONS,
  CLEAR_ERRORS
} from '../types';

export default (state, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
        loading: false
      };
    
    case GET_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: action.payload,
        loading: false
      };
    
    case MARK_NOTIFICATIONS_READ:
      return {
        ...state,
        notifications: state.notifications.map(notification => 
          action.payload.includes(notification._id)
            ? { ...notification, isRead: true }
            : notification
        ),
        loading: false
      };
    
    case DELETE_NOTIFICATIONS:
      return {
        ...state,
        notifications: state.notifications.filter(
          notification => !action.payload.includes(notification._id)
        ),
        loading: false
      };
    
    case NOTIFICATION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
        unreadCount: 0,
        loading: false
      };
    
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null
      };
    
    default:
      return state;
  }
};